/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPatientResponse } from './PccPatientResponse';
import {
    PccPatientResponseFromJSON,
    PccPatientResponseFromJSONTyped,
    PccPatientResponseToJSON,
    PccPatientResponseToJSONTyped,
} from './PccPatientResponse';

/**
 * 
 * @export
 * @interface FindOnePccPatient200Response
 */
export interface FindOnePccPatient200Response {
    /**
     * 
     */
    data?: PccPatientResponse;
}

/**
 * Check if a given object implements the FindOnePccPatient200Response interface.
 */
export function instanceOfFindOnePccPatient200Response(value: object): value is FindOnePccPatient200Response {
    return true;
}

export function FindOnePccPatient200ResponseFromJSON(json: any): FindOnePccPatient200Response {
    return FindOnePccPatient200ResponseFromJSONTyped(json, false);
}

export function FindOnePccPatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePccPatient200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PccPatientResponseFromJSON(json['data']),
    };
}

export function FindOnePccPatient200ResponseToJSON(json: any): FindOnePccPatient200Response {
    return FindOnePccPatient200ResponseToJSONTyped(json, false);
}

export function FindOnePccPatient200ResponseToJSONTyped(value?: FindOnePccPatient200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PccPatientResponseToJSON(value['data']),
    };
}

